<template>
    <div>
        <div
            v-for="(print_area, index) in print_areas"
            :key="index"
            :class="
                print_area.label.toLowerCase() == current_flip
                    ? 'btn_front active'
                    : 'btn_front'
            "
        >
            <div v-if="showIcons(print_area)">
                <button
                    :id="print_area.label + '_flipbtn'"
                    type="button"
                    class="btn"
                    :title="print_area.label + ' View'"
                    @click="changeImageView(print_area.label, index)"
                    :data-original-title="print_area.label + ' View'"
                >
                    <img
                        name="tshirtview"
                        id=""
                        :src="print_area.short_thumbnail_image"
                    />
                </button>
                <p>{{ print_area.label_show || print_area.label }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
    name: "PrintAreaIcons",
    props: {
        product_type_id: {
            type: String,
            default: () => localStorage.getItem("product_type_id")
        },
        front_show: {
            type: Boolean,
            default: () => true
        },
        back_show: {
            type: Boolean,
            default: () => true
        },
        left_show: {
            type: Boolean,
            default: () => true
        },
        right_show: {
            type: Boolean,
            default: () => true
        },
        product_design_area: {
            type: Array,
            default: () => []
        },
        current_flip: {
            type: String,
            default: () => localStorage.getItem("active_flip")
        },
        gender_groups: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        colorsValidation: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            isLoader: false,
            print_areas: []
        };
    },
    components: {},
    computed: {},
    watch: {},
    mounted() {
        this.getPrintArea();
    },
    methods: {
        getPrintArea() {
            let _this = this;
            ApiService.get("/product-types/" + this.product_type_id)
                .then(({ data }) => {
                    if (data.product_type.canvas_design_areas) {
                        _this.print_areas = JSON.parse(
                            data.product_type.canvas_design_areas
                        );
                        _this.print_areas.forEach((element, key) => {
                            if (
                                typeof _this.product_design_area[key] !==
                                    "undefined" &&
                                _this.product_design_area[key].label ===
                                    element.label
                            ) {
                                if (
                                    "label_show" in
                                    _this.product_design_area[key]
                                )
                                    _this.print_areas[key].label_show =
                                        _this.product_design_area[
                                            key
                                        ].label_show;
                                else
                                    _this.print_areas[key].label_show =
                                        _this.product_design_area[key].label;
                            } else {
                                _this.print_areas.splice(key, 1);
                            }
                        });
                        // Trigger function
                        _this.$emit("getPrintAreaParent", _this.print_areas);
                        _this.$emit(
                            "changePrintArea",
                            _this.print_areas[0].label
                        );
                        this.changeImageView(_this.current_flip.charAt(0).toUpperCase() + _this.current_flip.slice(1));
                    }
                    _this.isLoader = false;
                })
                .catch(({ response }) => {
                    console.log(response);
                    _this.isLoader = false;
                });
        },
        changeImageView(printArea, index) {
            if (this.disabled) {
                this.$toast.error(this.colorsValidation, {
                    position: "top-right",
                    queue: true
                });
                return;
            }
            console.log(index);
            let print_area = "front";
            if (printArea == "Front") {
            } else if (printArea == "Back") {
                print_area = "back";
            } else if (["Left", "Left Sleeve"].includes(printArea)) {
                print_area = "left";
            } else if (["Right", "Right Sleeve"].includes(printArea)) {
                print_area = "right";
            }
            // Trigger function
            this.$emit("flipTshirt", print_area);
            // Add Active Class
            this.$emit("changePrintArea", print_area);
        },
        showIcons(print_area) {
            // If disable
            if (!print_area.selected) {
                return false;
            }
            // Print Area
            if (print_area.label == "Front") {
                return this.front_show;
            } else if (print_area.label == "Back") {
                return this.back_show;
            } else if (print_area.label == "Left") {
                return this.left_show;
            } else if (print_area.label == "Right") {
                return this.right_show;
            }

            return true;
        }
    }
};
</script>
